import { Fallback } from "@radix-ui/react-avatar";
import React from "react";
import { AVATAR_FALLBACK_CLASSNAME } from "./constants";
import { BaseAvatarContainer, BaseAvatarImage } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function BaseAvatar(_ref) {
  var initials = _ref.initials,
    color = _ref.color,
    size = _ref.size,
    imageSrc = _ref.imageSrc;
  return /*#__PURE__*/_jsxs(BaseAvatarContainer, {
    size: size,
    color: color,
    children: [/*#__PURE__*/_jsx(BaseAvatarImage, {
      src: imageSrc
    }), /*#__PURE__*/_jsx(Fallback, {
      className: AVATAR_FALLBACK_CLASSNAME,
      children: initials
    })]
  });
}
export default BaseAvatar;